export const VERSION_TAG = '1.16.0'

export const V1_8_1 = {
    order: 1,
    tag: '1.8.1',
    text: [
        `<strong>Automatické zapomatování filtru, řazení a stránkování.</strong> ASD si pomatuje vaše poslední operace v tabulkovém výpisu
        projektů a znovu je použije když se do výpisu vrátíte. Toto zapomatování funguje pro každou sekci zvlášť.`,
        `<strong>Gantt</strong> přeložen do češtiny.`,
        `<strong>Nastavení Flexibee</strong> doplněny všechny možné položky pro synchronizaci.`,
        `<strong>Detail typy ANO/NE</strong> zobrazuje text namísto ikonek`,
        `<strong>Gantt</strong> nově umožňuje zoom.`,
        `<strong>Výchozí hodnotu pro ANO/NE a Textový řetězec</strong> je možné zadat v nastavení vlastnosti a tato statická hodnota se předvyplní
        při tvorbě nové položky`,
        `<strong>Nové dělení úkolů a projektů</strong> podle stavu (aktivní, koč). Rozdělení je dle otagované vlastnosti ANO/NE`,
        `<strong>Uložené filtry</strong> se již ukládají uživateli a nikoliv jenom na lokálním počitači.`,
        `<strong>Načítáni dat</strong> bylo trochu graficky vylepšeno aby bylo vidět lépe co se děje.`,
    ],
}

export const V1_9_0 = {
    order: 2,
    tag: '1.9.0',
    text: [
        `<strong>Gantt</strong> nově kompletně předělaný tak aby šlo posouvat úkoly pomocí myši.`,
        `<strong>Redesign</strong> příloh a komentářů.`,
        `<strong>Fix</strong> mizejících filtrů.`,
        `<strong>Grafické zvýraznění</strong> smazaných úkolů a projektů.`,
        `<strong>Flow</strong> kompletně nový stavový diagram pro stavy úkolú a projektů.`,
        `<strong>Editor</strong> uživatelů a hesel.`,
        `<strong>Export</strong> tabulek úkolů a projektů.`,
    ],
}

export const V1_9_1 = {
    order: 3,
    tag: '1.9.1',
    text: [
        `<strong>Fix</strong> filtrování podle uživatele a typu datum.`,
        `<strong>Fix</strong> autodotažení dopočítané defaultní hodnoty.`,
        `<strong>Zdroje</strong> deaktivace a re-aktivace.`,
        `<strong>Uživatelé</strong> deaktivace uživatelsého účtu a zablokování přihlášení.`,
        `<strong>Synchronizace FB</strong> přidána možnost mazání.`,
        `<strong>Nástěnka</strong> přidána možnost si zapnout tabulku projektů kde jsem zpracovatelem.`,
        `<strong>Typy zdrojů/úkolů</strong> přidáno varování na vylučující se (nekompatibilní) vlastnosti.`,
        `<strong>Gantt</strong> možnost si zapnout manuální ukládání narozdíl od automatického (výchozí)`,
    ],
}

export const V1_9_2 = {
    order: 4,
    tag: '1.9.2',
    text: [
        `<strong>Soubory</strong> upraveny na windows lomítka.`,
        `<strong>Soubory</strong> možnost ručního znovu načtení.`,
        `<strong>Soubory</strong> přidána podpora pro cestu složenou z více vlastností.`,
        `<strong>Soubory</strong> základní složka z názvu typu projektu.`,
    ],
}

export const V1_10_0 = {
    order: 5,
    tag: '1.10.0',
    text: [
        `<strong>Editace/Zamykani</strong> vytvořeno zamykání editace projektů.`,
        `<strong>Filtr</strong> zvýraznění aktuálně nahraného filtru`,
        `<strong>Komentáře</strong> komentáře upraveny ve stylu facebooku tzn. možno odpovědět na komentář nebo zmínit komentář.`,
        `<strong>Gui</strong> přidáno tlačítko zpět do záhlaví detailu projektu/úkolu.`,
    ],
}

export const V1_11_0 = {
    order: 6,
    tag: '1.11.0',
    text: [
        '<strong>Vlastnosti</strong> se nyní vymaže za určitých podmínek úplně namísto zanechané prázdné hodnoty (neplatí pro čísla a progress).',
        '<strong>Nápovědní texty</strong> aktualizovány a pročiětěny.',
        '<strong>Vlastnost dlouhy text</strong> má hezčí detail pomocí popupu, při zvolené minimální délce detailu se ořízne max na 10 prvních slov',
        '<strong>fix</strong> nefunkčních záložek pro úkoly v detailu projektu',
        '<strong>fix</strong> neupdatujících se vlastností do detailu projektu',
        '<strong>bugfix</strong> výchozího žazení tabulek',
        '<strong>bugfix</strong> nedoplňujícího se autora (vlastnost vazba na uživatele - tag author)',
    ],
}

export const V1_12_0 = {
    order: 7,
    tag: '1.12.0',
    text: [
        '<strong>Automatické hodnoty</strong> se nyní doplňují automaticky na API.',
        '<strong>Datum vytvoření</strong> je možné i pro vlastnost datum, nejen datum a čas.',
        '<strong>Historie stavu</strong> se zobrazuje nyní i u projektu, nejen u úkolů',
        '<strong>Fix vyhledávání</strong> kdy pro učité kombinace malých a velkých písmen blblo.',
        '<strong>Vymazané úkoly</strong> se nyní zobrazují v detailu projektu na vlastní záložce.',
        '<strong>Přesun úkolu</strong> je nyní možný pod jiný projekt.',
        '<strong>Layout detailu</strong> byl upraven tak aby se méně roztahoval a tabulka vlastností se scroluje.',
    ],
}

export const V1_13_0 = {
    order: 8,
    tag: '1.13.0',
    text: [
        '<strong>Nastavení notifikací</strong> je nyní možné provést v sekci nastavení.',
        '<strong>Historie změn stavu</strong> je zkrácena na 3 položky ve výchozím zobrazení, možno si rozkliknout více.',
        '<strong>Historie všech změn</strong> se nyní loguje a zobrazuje pro entity.',
        '<strong>Modul záložek</strong> který umožňujě jednoduše vkládat obsah do záložek. Použito pro historie stavu a změn.',
        '<strong>Update (Websocket) </strong> upraven tak aby se korektně znovupřipojoval registroval se pro příjem dat po připojení.',
        '<strong>Aktivní button</strong> pro ukládání detailu úkolu a zdrojů tak aby se zablokovalo mnohonásobné kliknutí.',
        '<strong>Stav</strong> není možno editovat pokud se zakládá v nové entitě. Vynucuje se tím defaultní stav při založení nové entity.',
        '<strong>Reset workflow</strong> je nyní možné provést pokud má uživatel speciální oprávnění.',
    ],
}

export const V1_14_0 = {
    order: 9,
    tag: '1.14.0',
    text: [
        '<strong>Samba</strong> nastavení.',
        '<strong>UI Fix</strong> při přidávání úkolů ikonka save namísto plus.',
        '<strong>UI Fix</strong> řazení na nástěnce.',
        '<strong>Fix</strong> sorteru kdy si nepomatoval v něterých situacích předchozí stav.',
    ],
}

export default [
    V1_8_1,
    V1_9_0,
    V1_9_1,
    V1_9_2,
    V1_10_0,
    V1_11_0,
    V1_12_0,
    V1_13_0,
    V1_14_0,
]
